module.exports = __webpack_public_path__ + "static/media/exchange_tooltip.21e3df34.svg";